module.exports = __webpack_public_path__ + "img/outher.c0bdaea4.svg";